import { useState } from 'react'

import { useDebounce, useSetState } from '@domain-group/react-hooks'

import usePublicationPaginationRule from '@hooks/usePublicationPaginationRule'
import usePublications from '@hooks/usePublications'
import useSelector from '@hooks/useSelector'

import type { PublicationPaginationRuleModel } from '@models/types'

const defaultState = {
  provider_id: undefined,
  string: '',
}

const useManagePublicationPaginationRulesModal = (
  publicationPaginationRule: Partial<PublicationPaginationRuleModel> = {},
) => {
  const [state, setState] = useSetState(defaultState)
  const { provider_id, string } = state

  const [selectedPublicationIds, setSelectedPublicationIds] = useState<number[]>([])

  const {
    callbacks: { manageForPaginationRule },
    paginationRule,
    updating,
  } = usePublicationPaginationRule(publicationPaginationRule)

  const debouncedString = useDebounce(string, 200)

  const publicationsPayload = usePublications({
    filters: {
      // @ts-expect-error TS2322
      provider_assigned_brand_id: provider_id ? null : paginationRule?.brand_id,
      provider_id,
      string: debouncedString,
    },
    performHttpRequests: provider_id || debouncedString.length > 1,
    requestOptions: { include_publication_provider_assigned_brand_ids: true },
  })

  const {
    callbacks: {
      loadMore,
    },
    canLoadMore,
    filteredPublications,
    filteredPublicationsCount,
    loading: loadingPublications,
  } = publicationsPayload

  const filteredPublicationIds = filteredPublications.map(publication => publication.id)

  const publications = useSelector(reduxState => reduxState.entities.publications)

  return {
    callbacks: {
      loadMore,
      manageForPaginationRule,
      setSelectedPublicationIds,
      setState,
    },
    canLoadMore,
    filteredPublicationIds,
    filteredPublicationsCount,
    hasActiveFilters: !!provider_id || !!debouncedString,
    loadingPublications,
    paginationRule,
    publications,
    saveEnabled: !!selectedPublicationIds.length,
    selectedPublicationIds,
    state,
    updating,
  }
}

export default useManagePublicationPaginationRulesModal
